import React from 'react';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  return (
    <header className="w-full bg-white border-b border-gray-200 -mt-px">
      <div className="h-12 px-3 lg:px-4 flex items-center justify-end">
        <div className="flex items-center">
          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
};

export default Header;


